import React from "react";

const FromCognito = () =>{
  return <div/>
};

export default FromCognito;
